var render = function render(){var _vm=this,_c=_vm._self._c;return _c('answers',{ref:"answers",attrs:{"code_question_group":"GQ26","danger_code":"MCAL14","unique_category":true,"control_question":"QCAL162","control_answer":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }